import { useMutation } from '@tanstack/react-query';
import { useAtom } from 'jotai';

import { post } from 'api/utils';
import ENDPOINTS from 'api/utils/endpoints';
import { useSelectedDealerId } from '@lotlinx-aws/dealer-selector';
import { PerformanceMetrics } from 'pages/Campaign/PerformanceResults/api/usePerformanceResultsNotification/usePerformanceResultsNotification';
import { userAtom } from 'store';
import { assertIsDefined } from 'util/assert';

interface UsePostPerformanceResultsNotificationProps {
  revealedMetrics?: {
    [key: string]: PerformanceMetrics[];
  };
  isInitialLogin?: boolean;
}

interface PostPerformanceResultsNotificationProps {
  token?: string;
  dealerId?: number;
  revealedMetrics?: {
    [key: string]: PerformanceMetrics[];
  };
  isInitialLogin?: boolean;
}

/**
 * usePerformanceResultsNotification
 * @param prop
 */

async function postPerformanceResultsNotification({
  token,
  dealerId,
  revealedMetrics,
  isInitialLogin,
}: PostPerformanceResultsNotificationProps) {
  assertIsDefined(token);
  assertIsDefined(dealerId);

  return await post(`${ENDPOINTS.performanceResultsNotification}/${dealerId}`, {
    headers: { token },
    body: {
      revealedMetrics,
      isInitialLogin,
    },
  });
}

export default function usePostPerformanceResultsNotification() {
  const [dealerId] = useSelectedDealerId();
  const [user] = useAtom(userAtom);

  return useMutation({
    mutationFn: ({ revealedMetrics, isInitialLogin }: UsePostPerformanceResultsNotificationProps) =>
      postPerformanceResultsNotification({
        token: user?.token,
        dealerId,
        revealedMetrics,
        isInitialLogin,
      }),
  });
}
